export const ADMIN_SCREENS = {
  TABLE: 'table',
  FORM: 'form',
};